import { render, staticRenderFns } from "./ContentCardSkeleton.vue?vue&type=template&id=58ef1968&scoped=true"
import script from "./ContentCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ContentCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ContentCardSkeleton.vue?vue&type=style&index=0&id=58ef1968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ef1968",
  null
  
)

export default component.exports